import { useState } from "react";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { RotateCcw } from "lucide-react";
import { useTutorialContext } from "@/context/tutorial/TutorialContext";
import { useThemeConfig } from "@/components/ui/theme-config-provider";

const SettingsTutorialSection = () => {
  const { preferences, setGlobalEnabled, resetAllTutorials } =
    useTutorialContext();
  const [isResetting, setIsResetting] = useState(false);
  const { theme } = useThemeConfig();

  const handleToggle = async (checked: boolean) => {
    await setGlobalEnabled(checked);
  };

  const handleResetTutorials = async () => {
    setIsResetting(true);
    await resetAllTutorials();
    setIsResetting(false);
  };

  return (
    <div
      className="rounded-lg shadow p-6 mb-6"
      style={{
        borderRadius: theme.borderRadius || "0.5rem",
        backgroundColor:
          theme.cardBackgroundColor || theme.backgroundColor || "#ffffff",
      }}
    >
      <h2
        className="text-xl font-semibold mb-4"
        style={{ color: theme.sectionTitleColor }}
      >
        Guide Tutorial
      </h2>

      <div className="flex items-center justify-between py-3">
        <div>
          <Label
            htmlFor="tutorial-enabled"
            className="text-base font-medium"
            style={{ color: theme.sectionTextColor }}
          >
            Mostra guide
          </Label>
          <p className="text-sm" style={{ color: theme.sectionTextColor }}>
            Attiva o disattiva le guide tutorial per tutte le pagine dell'app
          </p>
        </div>
        <Switch
          id="tutorial-enabled"
          checked={preferences.globalEnabled}
          onCheckedChange={handleToggle}
          style={{
            backgroundColor: preferences.globalEnabled
              ? theme.primaryColor
              : undefined,
          }}
        />
      </div>

      <div
        className="mt-4 pt-4 border-t"
        style={{ borderColor: theme.borderColor }}
      >
        <Button
          className="w-full hover:opacity-90 disabled:opacity-50"
          onClick={handleResetTutorials}
          disabled={isResetting}
          style={{
            backgroundColor: theme.primaryColor,
            color: theme.textPrimaryColor,
            fontWeight: 'bold',
            borderRadius: theme.buttonBorderRadius || "0.375rem",
            padding: theme.buttonPadding || "0.5rem 1rem",
          }}
        >
          <RotateCcw className="h-4 w-4 mr-2" />
          {isResetting
            ? "Reimpostazione in corso..."
            : "Reimposta tutte le guide"}
        </Button>
        <p
          className="text-xs mt-2 text-center"
          style={{ color: theme.sectionTextColor }}
        >
          Questa opzione ripristina tutte le guide, mostrandole nuovamente come
          al primo utilizzo
        </p>
      </div>
    </div>
  );
};

export default SettingsTutorialSection;
